var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPicture = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#02607F",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#02607F",
    cx: 7,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17c.264-2.667.93-4 2-4 .788 0 2.817.819 4.487 1.715 2.821-1.015 3.95-4.238 4.975-4.637C15.86 9.533 16.706 11.841 17 17H3z",
    fill: "#02607F"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPicture);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-picture.c2b083dd09f934e4a1648269ca0b1ce1.svg";